import React from 'react';
import Badges from './Badges';
import { StarIcon } from 'lucide-react';
import { PiStudentBold } from "react-icons/pi";
import { IoTimeOutline } from "react-icons/io5";
import Stars from './Stars';

function CourseDetails({ course }) {
  if (!course) return null;

  const instructorName = course.instructor?.instructor_name || 'Ali Tufan';
  const instructorAvatar = course.instructor?.instructor_avatar || '/avatars/small-1.png';
  const categoryName = course.category?.name || 'Development';

  return (
    <div className='flex flex-wrap -mx-4 gap-y-8 relative bg-purple-1 py-10 px-5 rounded-lg'>
      {/* Colonne de gauche - Contenu principal */}
      <div className="w-full px-4 xl:w-7/12 lg:w-8/12">
        <Badges tags={course.tags} />

        {/* Titre principal */}
        <div data-anim="slide-up delay-1">
          <h1 className="text-2xl md:text-3xl font-semibold leading-snug md:leading-normal mb-4 text-white">
            {course.title}
          </h1>
          <p className="text-white text-sm">{course.subtitle || 'Learn UI/UX Design'}</p>
        </div>

        {/* Description */}
        <p className="mt-3 text-white text-base leading-relaxed">
          Niveau: {course.difficulty_level || 'Débutant'} | Catégorie: {categoryName} | 
          Langue: {course.language || 'Français'}
        </p>

        {/* Métriques */}
        <div className="flex flex-wrap items-center space-x-10 mt-6">
          {/* Note */}
          <div className='flex items-center justify-center'>
            <span className='text-green-1 font-semibold text-sm mr-2'>{course.rating || 0}</span>
            <Stars rating={course.rating || 4.5} />
            <span className="text-white ml-2 text-sm">({course.total_reviews || 0})</span>
          </div>

          {/* Étudiants */}
          <div className='flex items-center'>
            <PiStudentBold className="w-4 h-4 mr-2 text-white" />
            <span className="text-white text-sm">{course.total_enrollements || 0} enrolled</span>
          </div>

          {/* Durée */}
          <div className='flex items-center'>
            <IoTimeOutline className="w-4 h-4 mr-2 text-white" />
            <span className="text-white text-sm">{course.estimated_duration_hours || 0} hours</span>
          </div>
        </div>

        {/* Auteur */}
        <div className="flex items-center pt-6 mt-6">
          <div
            className="w-10 h-10 rounded-full bg-cover bg-center"
            style={{
              backgroundImage: `url(${instructorAvatar})`
            }}
          />
          <div className="text-sm ml-3 text-white font-sans">
            {instructorName}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseDetails;